@use '@konova/styles/styles';

.root {
  --modal--width: var(--theme--tokens--modal--width-default);
  --modal--paddings: calc(var(--theme--tokens--modal--padding) / 2) var(--theme--tokens--modal--padding);
  --modal--panel-index: var(--theme--index--layer--modal);
  --modal--backdrop-index: calc(var(--theme--index--layer--modal) - 1);

  &.maxheight {
    .panel {
      height: 100%;
      max-height: 90vh;
    }
  }

  &.scrollable {
    .header {
      border-bottom: 1px solid var(--theme--tokens--modal--border-color);
    }

    .footer {
      border-top: 1px solid var(--theme--tokens--modal--border-color);
    }

    .contentWrapper {
      padding-right: calc(var(--theme--tokens--modal--padding) - var(--theme--sizing--2x));
    }
  }

  &.draggable {
    transform: translate3d(0, 0, 0);
    top: 1vh;
    left: calc(50% - var(--modal--width) / 2);
  }

  &.relative {
    position: relative;

    .backdrop {
      position: absolute;
    }

    .panel {
      position: relative;
      transform: translate3d(-50%, 0, 0);
      top: unset;
    }
  }

  &.noPadding {
    .contentWrapper {
      padding: 0;
    }
  }

  .card {
    display: flex;
    flex-direction: column;
    flex: 1;

    @include styles.mq('max', 'small') {
      border-radius: 0;
    }
  }

  .header {
    position: relative;
    padding-top: 9px;
    padding-left: var(--theme--tokens--modal--padding);
    padding-right: var(--theme--tokens--modal--padding);

    &.close {
      padding-right: var(--theme--sizing--2x);
    }
  }

  .footer {
    padding: var(--modal--paddings);
  }

  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: translate3d(-50%, -45%, 0) scale(0.95);
    }

    to {
      opacity: 1;
      transform: translate3d(-50%, -50%, 0) scale(1);
    }
  }

  .panel {
    z-index: var(--modal--panel-index);
    position: fixed;
    display: flex;
    flex-direction: column;
    transform: translate3d(-50%, -50%, 0);
    left: 50%;
    top: 50%;
    width: 100%;
    max-width: var(--modal--width);
    max-height: 90vh;
    overflow: hidden;
    animation: fadeInScale 0.3s ease-in-out;
    transition: max-width var(--theme--transition--default);

    @include styles.mq('max', 'large') {
      max-height: 100vh;
      height: 100%;
      max-width: 100%;
    }
  }

  .modalContent {
    overflow: auto;
    flex: 1;
    padding: 0;
    position: relative;

    --theme--index--layer--content: 31;
    --theme--index--layer--header: 32;
  }

  .contentWrapper {
    padding: var(--modal--paddings);
  }
}

.backdrop {
  z-index: var(--modal--backdrop-index);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--theme--tokens--modal--backdrop-color);
}